import { HTTP } from "../../http-common";
import { createHelpers } from "vuex-map-fields";
import { httpError } from "../../models/httpError";
import { UserPermission } from '../../models/UserPermission'
import { getField, updateField } from "vuex-map-fields";

const state = {
    rows: [],
    user: {},
    message: new httpError(),
};

const getters = {
    rows: (state) => {
        return state.rows;
    },
    user: (state) => {
        return state.user;
    },
    message: (state) => {
        state.message;
    },
    permissionLevelOptions: (state) => {
        state.permissionLevelOptions;
    },
    getField,
};

const actions = {
    setMessage({ commit }, message) {
        commit("setProgress", message);
        if (message.httpStatus !== 500)
            setTimeout(() => {
                commit("setProgress", new httpError());
            }, 2000);
    },

    getUserPermissions({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            HTTP.get("permission/GetAllUserPermissions")
                .then((res) => {
                    if (res.status == 200) {
                        let permissions = res.data.data.map((item) => {
                            return new UserPermission(item)
                        })
                        commit("setUserPermissions", permissions);
                    } else commit("reset");
                    dispatch(
                        "setMessage",
                        new httpError({ message: "Retreived OK", httpStatus: 200 })
                    );
                    resolve(res.data);
                })
                .catch((err) => {
                    dispatch(
                        "setMessage",
                        new httpError({
                            message: "Error getting Interested:" + err,
                            httpStatus: 500,
                        })
                    );
                    reject(err);
                });
        });
    },
    getUserPermissionByEmail({ commit, dispatch }, email) {
        return new Promise((resolve, reject) => {
            HTTP.get(`permission/GetUserPermissionByEmail/${email}`)
                .then((res) => {
                    commit("setUser", res.data)
                    resolve(res.data);
                })
                .catch((err) => {
                    dispatch(
                        "setMessage",
                        new httpError({
                            message: "Error getting Interested:" + err,
                            httpStatus: 500,
                        })
                    );
                    reject(err);
                });
        });
    },
    updateUserPermissions({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            HTTP.post("permission/UpsertUserPermission", data)
                .then((res) => {
                    if (res.status == 200) {
                        dispatch("getUserPermissions");
                    } else commit("reset");
                    dispatch(
                        "setMessage",
                        new httpError({ message: "Update OK", httpStatus: 200 })
                    );
                    resolve(res.data);
                })
                .catch((err) => {
                    dispatch(
                        "setMessage",
                        new httpError({
                            message: "Error getting Interested:" + err,
                            httpStatus: 500,
                        })
                    );
                    reject(err);
                });
        });
    },
    removeUserPermission({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            HTTP.post("permission/DeleteUserPermission", data)
                .then((res) => {
                    if (res.status == 200) {
                        dispatch("getUserPermissions");
                    } else commit("reset");
                    dispatch(
                        "setMessage",
                        new httpError({ message: "Update OK", httpStatus: 200 })
                    );
                    resolve(res.data);
                })
                .catch((err) => {
                    dispatch(
                        "setMessage",
                        new httpError({
                            message: "Error" + err,
                            httpStatus: 500,
                        })
                    );
                    reject(err);
                });
        });
    },
};

const mutations = {
    setProgress(state, message) {
        state.message = message;
    },
    setUserPermissions(state, data) {
        state.rows = data;
    },
    setUser(state, data) {
        state.user = new UserPermission(data.data);
    },
    reset(state) {
        state.rows = [];
        state.message = new httpError();
    },
    updateField,
};

const modules = { };
export const { mapFields: mapUserPermissionsFields } = createHelpers({
    getterType: `userPermissions/getField`,
    mutationType: `userPermissions/updateField`,
});

export const {
    mapMultiRowFields: mapUserPermissionsMultiRowFields,
} = createHelpers({
    getterType: "userPermissions/getField",
    mutationType: "userPermissions/updateField",
});

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules,
};
